import React from "react";
import { useNavigate } from "react-router-dom";
import { CButton, CContainer } from "@coreui/react-pro";
import PublicSiteShell from "../../components/public/PublicSiteShell";
import "../../styles/public-experience.css";
import "../../styles/public-family-alignment.css";

const MnuTools = () => {
  const navigate = useNavigate();

  const hero = (
    <section className="public-info-hero">
      <CContainer fluid className="public-core-container public-page-shell public-info-shell">
        <div className="public-info-hero__panel public-page-hero-panel">
          <div className="public-info-hero__copy">
            <span className="public-core-eyebrow public-page-overline">Tools</span>
            <h1 className="public-page-title">Digitale Werkzeuge für klare nächste Schritte</h1>
            <p className="public-page-body public-info-hero__lead">
              Experts4Europe bündelt Bewerbung, Sichtbarkeit, Sprachstand und Orientierung in
              einer ruhigen, gemeinsamen Produktlogik statt in voneinander getrennten Inseln.
            </p>
            <div className="public-legal-chip-row">
              <span>Bewerbung</span>
              <span>Sprache</span>
              <span>Matching</span>
            </div>
          </div>
          <aside className="public-info-hero__meta">
            <div className="public-page-callout public-info-callout">
              <strong>Für Fachkräfte</strong>
              <span>CV, Sprache, Readiness und Chancen greifen strukturiert ineinander.</span>
            </div>
            <div className="public-page-callout public-info-callout">
              <strong>Für Arbeitgeber</strong>
              <span>Profile, Nachweise und Entscheidungsvorbereitung bleiben nachvollziehbar gebündelt.</span>
            </div>
          </aside>
        </div>
      </CContainer>
    </section>
  );

  return (
    <PublicSiteShell pageClassName="public-info-page" hero={hero}>
      <section className="public-core-band public-core-band--light">
        <CContainer fluid className="public-core-container public-page-shell public-info-shell">
          <div className="public-info-stack">
            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Für Fachkräfte</span>
              <div className="public-info-list">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Bewerbung und Nachweise</h2>
                  <p className="public-page-body">CV, Skills, Referenzen und Nachweise werden gemeinsam statt als lose Einzelschritte geführt.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Sprache und Readiness</h2>
                  <p className="public-page-body">Sprachstand, Vorbereitung und konkrete Lücken werden sichtbar, ohne den nächsten Schritt aus dem Blick zu verlieren.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Chancen und Orientierung</h2>
                  <p className="public-page-body">Matching und öffentliche Stellen werden mit nachvollziehbarer Einordnung statt mit unruhiger Datenfülle verbunden.</p>
                </div>
              </div>
            </article>

            <article className="public-page-card public-info-card">
              <span className="public-core-eyebrow public-page-overline">Für Arbeitgeber</span>
              <div className="public-info-list">
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Klare Kandidatenlagen</h2>
                  <p className="public-page-body">Arbeitgeber sehen keine Datensammlung, sondern eine strukturierte Bewerberlage mit den relevanten Signalen.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Vergleichbare Signale</h2>
                  <p className="public-page-body">Sprache, Unterlagen, Filing-Readiness und Fortschritt werden nachvollziehbar und ruhig lesbar gemacht.</p>
                </div>
                <div className="public-page-value-card public-info-value-card">
                  <h2 className="public-page-subtitle">Ein gemeinsames System</h2>
                  <p className="public-page-body">Fachkräfte und Arbeitgeber arbeiten mit derselben Produktlogik statt mit gegeneinander laufenden Teilwelten.</p>
                </div>
              </div>
            </article>

            <div className="public-info-actions public-page-card">
              <div className="public-info-actions__copy">
                <span className="public-core-eyebrow public-page-overline">Direkter Einstieg</span>
                <h2 className="public-page-subtitle">Weiter im passenden öffentlichen Pfad</h2>
              </div>
              <div className="public-info-actions__buttons">
                <CButton type="button" className="public-core-btn public-core-btn--primary" onClick={() => navigate("/applicant/frontdoor?entry=abroad")}>
                  Quick Check starten
                </CButton>
                <CButton type="button" className="public-core-btn public-core-btn--subtle" onClick={() => navigate("/register")}>
                  Für Arbeitgeber starten
                </CButton>
              </div>
            </div>
          </div>
        </CContainer>
      </section>
    </PublicSiteShell>
  );
};

export default MnuTools;
